﻿export class AANCarouselCardFeature {
	init(): void {
		const carouselFeaturedCards: HTMLElement[] = [].slice.call(document.querySelectorAll(".carousel .card-featured"));

		if (!carouselFeaturedCards?.length) {
			return;
		}

		carouselFeaturedCards.forEach(carouselFeaturedCard => {
			this.computeHeight(carouselFeaturedCard);

			window.addEventListener("resize", () => {
				this.computeHeight(carouselFeaturedCard);
			});
		});
	}

	private computeHeight(carouselFeaturedCard: HTMLElement) {
		const paragraph = carouselFeaturedCard.querySelector("p");

		// The css styles are applying a `height: 0 !important;` style. We want to temporarily override it to compute the height.
		paragraph!.setAttribute('style', 'height: auto !important;');

		// Wait for the browser to apply the temporary height so we can compute the height of the element.
		requestAnimationFrame(() => {
			// Add a "height" style directly to the element that will be the height of the elements content.
			// The css file will apply a height of 0 until the user hovers over the card.
			// We are doing it this way so we can have a transition for the content to slide up over the course of 300 miliseconds.
			// In order to do that the heights must be known, you cannot use a height of "auto" or "max-content" as the transition will not be applied.
			const contentHeight = getComputedStyle(paragraph!).height;
			paragraph!.style.height = `calc(${contentHeight} + var(--block-gap))`;
		});
	}
}


document.addEventListener("DOMContentLoaded", () => {
	const carouselCardFeatured = new AANCarouselCardFeature();

	carouselCardFeatured.init();
});
